import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API, GROUPED_BY } from "@constants"
import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from "@signals"
import { catalogueAnalyzerTabSelected, elementsInLoading } from "../../@signals"


export default function useCatalogueAnalyzerPriceNumProductsChart() {

	const isLoading = useSignal(false)
	const data = useSignal([])
	const chartKeys = useSignal([])
	const selectOptions = useSignal([])
	const selectValue = useSignal(-1)

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoading.value = true
			data.value = []
			selectValue.value = -1
			postSubmit(`${WEBBACK_V2_API}/catalogue/price-num-products`, { 
				...commonFiltersValue.value, groupedBy: catalogueAnalyzerTabSelected.value
			}).then(res => {
				data.value = res.chartData
				chartKeys.value = res.chartKeys
				selectOptions.value = res.options
			})
			.catch(() => {
				isSystemBusy.value = true
				isLoadingCommonFilters.value = false
			}).finally(() => isLoading.value = false)
		}
	}, [isLoadingCommonFilters.value])

	useEffect(() => {
		if (isLoading.value)
			elementsInLoading.value = [...elementsInLoading.value, 'priceNumProductsChart']
		else{
			elementsInLoading.value = elementsInLoading.value.filter(item => item !== 'priceNumProductsChart')
		}
	}, [isLoading.value])

	const handleChangeOptions = (e) => {
		selectValue.value = e.target.value
		isLoading.value = true
		data.value = []
	
		const payload = {
			...commonFiltersValue.value, 
			groupedBy: catalogueAnalyzerTabSelected.value
		}
	
		if (catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND) {
			payload.brand = selectValue.value !== -1 ? [selectValue.value] : []
		} 
		else if (catalogueAnalyzerTabSelected.value === GROUPED_BY.CATEGORY) {
			payload.category = selectValue.value !== -1 ? [selectValue.value] : []
		}
	
		postSubmit(`${WEBBACK_V2_API}/catalogue/price-num-products`, payload)
			.then(res => {
				data.value = res.chartData
				chartKeys.value = res.chartKeys
			})
			.finally(() => isLoading.value = false)
	}	

	return {
		isLoading: isLoading.value,
		data: data.value,
		chartKeys: chartKeys.value,
		selectOptions: selectOptions.value,
		selectValue: selectValue.value,
		handleChangeOptions: handleChangeOptions,
		title: 'Top 20 Share of Products Per ' + (catalogueAnalyzerTabSelected.value === GROUPED_BY.BRAND ? 'Brands' : 'Category')
	}
}